import { Car, Home, Wrench } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { ConvoyageForm } from "@/components/ConvoyageForm";
import { IMAGES } from "@/constants/images";

const useCases = [
  {
    icon: Car,
    title: "Achat ou vente à distance",
    text: "Vous achetez ou vendez un véhicule loin de chez vous : nous assurons le trajet.",
  },
  {
    icon: Home,
    title: "Déménagement ou mutation",
    text: "Votre véhicule vous attend à votre nouvelle adresse, sans que vous ayez à faire la route.",
  },
  {
    icon: Wrench,
    title: "Véhicule à rapatrier",
    text: "Rapatriement d'un véhicule vers le garage ou vers votre domicile, selon votre besoin.",
  },
];

export default function ConvoyagePage() {
  return (
    <div data-testid="convoyage-page">
      <PageHero
        image={IMAGES.hero}
        imageAlt="Convoyage automobile par MECA AUTO CLEAN 01"
        imageTestid="convoyage-bg-image"
        eyebrow="Convoyage auto"
        title="Nous transportons votre véhicule"
      >
        Achat à distance, déménagement, véhicule à rapatrier : MECA AUTO CLEAN 01
        conduit votre véhicule d'un point à un autre, en toute confiance.
        Décrivez votre trajet, nous vous répondons avec un devis.
      </PageHero>

      <section className="border-t border-border">
        <div className="mx-auto max-w-6xl px-4 py-20">
          <Reveal>
            <p className="mb-2 text-sm font-semibold uppercase tracking-[0.25em] text-primary">
              Le service
            </p>
            <h2 className="font-display text-3xl font-bold uppercase sm:text-4xl">
              Pour quels besoins ?
            </h2>
          </Reveal>
          <div className="mt-12 grid gap-6 sm:grid-cols-3">
            {useCases.map((u, i) => (
              <Reveal key={u.title} delay={i * 0.08}>
                <div
                  data-testid={`convoyage-case-${i + 1}`}
                  className="h-full rounded-lg border border-border bg-card p-6 transition-colors card-lift hover:border-primary/50"
                >
                  <u.icon className="h-7 w-7 text-primary" />
                  <h3 className="mt-4 font-semibold">{u.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{u.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="brand-panel border-t border-border">
        <div className="mx-auto max-w-3xl px-4 py-20">
          <Reveal>
            <h2 className="font-display text-3xl font-bold uppercase sm:text-4xl">
              Demander un convoyage
            </h2>
            <p className="mb-8 mt-4 text-muted-foreground">
              Indiquez le véhicule et le trajet : votre demande part directement
              sur le WhatsApp du garage, avec une copie par e-mail.
            </p>
          </Reveal>
          <div className="rounded-lg border border-border bg-card p-6">
            <ConvoyageForm />
          </div>
        </div>
      </section>
    </div>
  );
}
